<template>
  <button
    v-if="toggle.userExamDocument"
    class="status-icon document-upload-button"
    :class="'document-upload-button-' + status"
    @click="openModalAndEmitDocInfo()"
  >
    <md-icon :md-src="'/static/images/icon-doc-button-upload-' + status + '.svg'" />
    <md-tooltip
      md-delay="400"
      md-direction="top"
    >
      <span v-if="status === 'missing'">Anexar documento(s).</span>
      <span v-else>Documento(s) já anexado(s).</span>
    </md-tooltip>
    <span>DOC</span>
  </button>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { DOCUMENT_INFO, DOCUMENT_FINISH_UPLOAD, eventBus } from '@/api/eventbus'

export default {
  name: 'DocumentButton',
  props: {
    isDocumentDelivered: Boolean,
    examInfo: Object
  },
  computed: {
    ...mapGetters(['toggle']),
    status: function () {
      return this.isDocumentDelivered ? 'uploaded' : 'missing'
    }
  },
  created() {
    let self = this
    eventBus.$on(DOCUMENT_FINISH_UPLOAD, function () {
      self.$emit('refresh-list')
    })
  },
  methods: {
    ...mapActions(['setDocumentUploadModalVisible']),
    openModalAndEmitDocInfo() {
      eventBus.$emit(DOCUMENT_INFO, this.examInfo)
      this.setDocumentUploadModalVisible(true)
    }
  }
}
</script>

<style lang="scss" scoped>
  .document-upload-button {
    width: 62px;
    height: 23px;
    font-family: Roboto-bold, Roboto, sans-serif;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 12.5px;

    .md-icon {
      position: relative;
      right: 3px;
    }

    span {
      margin: auto 6px auto 0;
    }

    &-missing {
      background-color: #fb8a00;
    }

    &-uploaded {
      background-color: #21d09b;
    }
  }
</style>
